function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v36H0V0z",
  fill: "#C74634"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.541 22.139c2.277 0 4.126-1.855 4.126-4.143a4.134 4.134 0 00-4.126-4.139H14.46a4.134 4.134 0 00-4.128 4.139 4.135 4.135 0 004.128 4.143h7.082zm-7.245 2.257c-3.52 0-6.376-2.865-6.376-6.4 0-3.534 2.855-6.393 6.376-6.393h7.408c3.52 0 6.373 2.86 6.373 6.393 0 3.54-2.853 6.403-6.373 6.403l-7.409-.003z",
  fill: "#fff"
});

function SvgOracleObjectArtifact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "oracle-object-artifact.4b826.svg";
export { SvgOracleObjectArtifact as ReactComponent };